<template>
  <div class="bombas">
    <div class="navbar-content">
      <Navbar />
    </div>
    <main class="all">
      <section class="card">
        <img src="../assets/bombas/1bombas.jpg" alt="Bomba Modelo ZKuV" class="icon" />
        <h3>Bomba Modelo ZKuV</h3>
        <a :href="bombaZKuVPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/2bombas.jpg" alt="Bomba Modelo ZMag" class="icon" />
        <h3>Bomba Modelo ZMag</h3>
        <a :href="bombaZMagPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/3bombas.jpg" alt="Bomba Modelo ZMix" class="icon" />
        <h3>Bomba Modelo ZMix</h3>
        <a :href="bombaZMixPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/4bombas.jpg" alt="Bomba Modelo ZNE" class="icon" />
        <h3>Bomba Modelo ZNE</h3>
        <a :href="bombaZNEPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/5bombas.jpg" alt="Bomba Modelo ZNEKu" class="icon" />
        <h3>Bomba Modelo ZNEKu</h3>
        <a :href="bombaZNEKuPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/6bombas.jpg" alt="Bomba Modelo ZNKu" class="icon" />
        <h3>Bomba Modelo ZNKu</h3>
        <a :href="bombaZNKuPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/7bombas.jpg" alt="Bomba Modelo ZNV" class="icon" />
        <h3>Bomba Modelo ZNV</h3>
        <a :href="bombaZNVPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/8bombas.jpg" alt="Bomba Modelo ZProp" class="icon" />
        <h3>Bomba Modelo ZProp</h3>
        <a :href="bombaZPropPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/9bombas.jpg" alt="Bomba Modelo ZVKu" class="icon" />
        <h3>Bomba Modelo ZVKu</h3>
        <a :href="bombaZVKuPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/10bombas.jpg" alt="Bomba Modelo ZN" class="icon" />
        <h3>Bomba Modelo ZN</h3>
        <a :href="bombaZNPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
      <section class="card">
        <img src="../assets/bombas/11bombas.jpg" alt="Bomba Modelo ZN-AT" class="icon" />
        <h3>Bomba Modelo ZN-AT</h3>
        <a :href="bombaZNATPDF" target="_blank">
          <button class="button">
            <img src="../assets/bombas/iconpdf.png" alt="Ícone PDF" class="icon-pdf" />Detalhes
          </button>
        </a>
      </section>
    </main>
    <Bottom />
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import Bottom from "./Bottom.vue";

import bombaZKuV from "../assets/bombas/FT_ZKuV.pdf";
import bombaZMag from "../assets/bombas/FT_ZMag.pdf";
import bombaZMix from "../assets/bombas/FT_ZMix.pdf";
import bombaZNAT from "../assets/bombas/FT_ZN-AT.pdf";
import bombaZN from "../assets/bombas/FT_ZN.pdf";
import bombaZNE from "../assets/bombas/FT_ZNE.pdf";
import bombaZNEKu from "../assets/bombas/FT_ZNEKu.pdf";
import bombaZNKu from "../assets/bombas/FT_ZNKu.pdf";
import bombaZNV from "../assets/bombas/FT_ZNV.pdf";
import bombaZProp from "../assets/bombas/FT_ZProp.pdf";
import bombaZVKu from "../assets/bombas/FT_ZVKu.pdf";
export default {
  name: "Bombas",
  components: {
    Navbar,
    Bottom,
  },
  data() {
    return {
      bombaZKuVPDF: bombaZKuV,
      bombaZMagPDF: bombaZMag,
      bombaZMixPDF: bombaZMix,
      bombaZNATPDF: bombaZNAT,
      bombaZNPDF: bombaZN,
      bombaZNEPDF: bombaZNE,
      bombaZNEKuPDF: bombaZNEKu,
      bombaZNKuPDF: bombaZNKu,
      bombaZNVPDF: bombaZNV,
      bombaZPropPDF: bombaZProp,
      bombaZVKuPDF: bombaZVKu,
    };
  },
};
</script>

<style scoped>
.bombas {
  background-color: #f5f5f5;
  background-image: linear-gradient(to right,
      rgba(52, 51, 51, 0.1) 2px,
      transparent 1px),
    linear-gradient(to bottom, rgba(52, 51, 51, 0.1) 2px, transparent 1px);
  background-size: 3.4vw 3.4vw;
}

.navbar-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

.all {
  display: flex;
  padding-top: 150px;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: #fff;
  padding: 15px;
  border-radius: 5px;
  height: 351px;
  width: 350px;
  margin: 0 50px 70px 50px;
  box-shadow: 3px 3px 3px #00000080;
}

h3 {
  color: #000000;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 21px;
  margin: 10px 0;
  text-align: center;
}

.icon {
  width: 100%;
  max-width: 100%;
  height: auto;
  box-shadow: 0px 0px 2px #000000cc;
  border-radius: 5px;
}

.button {
  color: #16181a;
  background-color: #ffc737;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  font-weight: 400;
  opacity: 0.85;
  text-align: center;
  border-radius: 4.5px;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  width: 100%;
  height: 100%;
  box-shadow: 2.9px 2.9px 4.3px #00000080;
}

.icon-pdf {
  color: #38393b;
  width: 14%;
  height: auto;
  margin-left: 0.4em;
  order: 1;
}

@media only screen and (max-width: 600px) {
  .card {
    padding: 15px;
    height: 70%;
    width: 70%;
    margin: 0 5vw 8vw 5vw;
  }

  h3 {
    font-size: 2.7vw;
    margin: 1.5vw 0;
  }

  .button {
    font-size: 3vw;
    min-width: 25px;
  }
}
</style>